/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const BRANCH_BOARD_RANK_COLUMN_WIDTH = 12;

export const BRANCH_BOARD_ACTIONS_COLUMN_WIDTH = 12;
